import React, { Fragment, useEffect, useState } from 'react';
import '../resources/css/block_Memberships.css';
import { useParams } from 'react-router-dom'

import Block from '../../../Scafolding/Block';
import { TextHeader, TextTitle } from '../../../Digital/TextHeaders';

import { Container, Row, Col, Table, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { SSDComps } from '../../../../Brands/SSD/Start';
//import { CompsAPI } from '../Shared/DataCompAPI';
import CompsAPI from '../Shared/DataCompAPI';
import Common from '../../../../Shared/Common';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose, faTable, faImage, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalBody } from 'reactstrap';
import ConfirmWindow from '../../../Digital/ConfirmWindow';

export const MembersWrapper = (props) => {
    let { view } = useParams();

    return (
        <MembersWrapperContent view={view} />
    );
}   
export default MembersWrapper;

export const MembersWrapperContent = (props) => {

    const [username, setUsername] = useState(
        sessionStorage.getItem('username') || ''
    );

    useEffect(() => {
    }, [username]);

    const [blockName, setBlockName] = useState("");
    const [userName, setUserName] = useState("");

    let SignIn = async () => {
        setUserName("Rico");
        sessionStorage.setItem('username', username);
    };

    let LogOut = async () => {
        sessionStorage.removeItem('username')
    };

    return (
        <Block name="Login" isAlt={false}>
            <Row>
                <Col lg="12" className="text-right">
                    <FormGroup>
                        <span>Welcome {userName}</span>
                        <Button onClick={LogOut}>Log Out</Button>
                    </FormGroup>
                    <FormGroup>
                        <Button onClick={SignIn}>Sign In</Button>
                    </FormGroup>
                </Col>
            </Row>
        </Block>
    );
}
